function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.19531 4.5896V0.283691L0.243164 5.23584H4.54834C5.0144 5.23584 5.19531 5.05493 5.19531 4.5896Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.29761 8.28638V10.0256C9.29761 10.8208 9.94531 11.467 10.7395 11.467H14.4827V18.1008C14.4827 18.5635 14.1069 18.9395 13.6433 18.9395H0.838379C0.376465 18.9395 0.000976562 18.5635 0.000976562 18.1008V6.19287H5.12427C5.69189 6.19287 6.15356 5.73267 6.15356 5.1665V0.0297852H13.6433C14.1069 0.0297852 14.4827 0.40625 14.4827 0.867188V6.84351H10.7395C9.94531 6.84351 9.29761 7.4917 9.29761 8.28638Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0974 8.28613V10.0261C25.0974 10.1174 25.0247 10.1904 24.9331 10.1904H19.0344C18.9453 10.1904 18.8706 10.2651 18.8706 10.3567V16.2529C18.8706 16.344 18.7976 16.4172 18.7068 16.4172H16.9668C16.8748 16.4172 16.8005 16.344 16.8005 16.2529V10.3567C16.8005 10.2651 16.7268 10.1904 16.6357 10.1904H10.74C10.6489 10.1904 10.5742 10.1174 10.5742 10.0261V8.28613C10.5742 8.19507 10.6489 8.12036 10.74 8.12036H16.6357C16.7268 8.12036 16.8005 8.04761 16.8005 7.95557V2.05786C16.8005 1.96631 16.8748 1.89355 16.9668 1.89355H18.7068C18.7976 1.89355 18.8706 1.96631 18.8706 2.05786V7.95557C18.8706 8.04761 18.9453 8.12036 19.0344 8.12036H24.9331C25.0247 8.12036 25.0974 8.19507 25.0974 8.28613Z",
  fill: "currentColor"
});

var SvgFilePlus = function SvgFilePlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilePlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filePlus.c170f2ee.svg";
export { ForwardRef as ReactComponent };